<template>
  <i
    :class="[
      `icon`,
      className,
      `mi-${size}px`,
      `mi-${name}`
    ]"
    :data-test="dataTest"
    aria-hidden="true"
  ></i>
</template>

<script>
// Maersk Design System Icon List from Constants
import { Icon_List } from "../../config/constant";

export default {
  name: "Icon",
  props: {
    /**
     * @description
     * Provides the class name
     */
    className: {
      type: String,
      default: "",
    },
    /**
     * @description
     * Provides the name of the icon
     * Select the Icons from Maersk Design System Icon List
     */
    name: {
      type: String,
      validator: (val) => Icon_List.includes(val),
      default: "check",
    },
    /**
     * @description
     * Provides the Size of the icon
     * Maersk Design System Icons supports 20px and 24px
     */
    size: {
      type: String,
      validator: (val) => ["20", "24"].includes(val),
      default: "20",
    },
    /**
     * @description
     * Provides the Data Test Attribute to the Icon component
     */
    dataTest: {
      type: String,
      default: "",
    },
  },
};
</script>
